import { z } from 'zod';
// Request and response schemas for the API layer
export const BootstrapRootUserRequestDTOSchema = z.object({});
//# sourceMappingURL=bootstrap-root-user.dto.js.map